import React, { useContext, useEffect, useState } from "react";
import { Card, List } from "semantic-ui-react";
import AppContext from "../contexts/AppContextProvider";
import { ICallDetailsAttribute } from "../services/ConfigurationService";
import { CallContext } from "../contexts/CallContext";

export function CallInfo() {
    const [state, setState] = useState<ICallDetailsAttribute[]>([]);

    const { config } = useContext(AppContext);
    const { contact } = useContext(CallContext);

    useEffect(() => {
        if (!contact) {
            setState([]);
            return;
        }

        contact.onRefresh(() => {
            refreshData(contact);
        });

        contact.onDestroy(() => {
            setState([]);
        });
    }, [contact]);

    // Load attributes here
    const refreshData = (contact: connect.Contact) => {
        const attributes = contact.getAttributes();
        const attrList = config.callDetails.visibleAttributes.map((attr) => {
            return {
                ...attr,
                value: attributes[attr.attributeKey]?.value || "Not Set",
            };
        });
        setState(attrList);
    };

    const renderContent = () => {
        if (!contact) {
            return <p>No Contact Available</p>;
        }
        if (state.length < 1) {
            return <p>No Contact Details</p>;
        }
        const attrList = state.map((attr, i) => (
            <List.Item key={`${attr.attributeKey}_${i}`}>
                <List.Content>
                    <List.Header as="a">{attr.label}</List.Header>
                    <List.Description>{attr.value}</List.Description>
                </List.Content>
            </List.Item>
        ));

        // Style Attribute Card Here
        return <List divided relaxed content={attrList}></List>;
    };

    return (
        <Card className="card-jmb" style={{ marginTop: "0px" }}>
            <Card.Content>{renderContent()}</Card.Content>
        </Card>
    );
}
